// Day-key math (runtime-agnostic, `YYYY-MM-DD` → UTC millis).
export const MS_PER_DAY = 86_400_000;

export function dayKeyToUtcMs(key: string): number {
  const [year, month, day] = key.split('-').map(Number);
  return Date.UTC(year, month - 1, day);
}

export function isOvernight(startTime: string, endTime: string): boolean {
  const validTime = /^(?:[01]\d|2[0-3]):[0-5]\d$/;
  return validTime.test(startTime) && validTime.test(endTime) && endTime < startTime;
}

export function resolveEndDateKey(dateKey: string, startTime: string, endTime: string): string {
  if (!isOvernight(startTime, endTime)) return dateKey;
  const nextDate = new Date(`${dateKey}T00:00:00.000Z`);
  nextDate.setUTCDate(nextDate.getUTCDate() + 1);
  return nextDate.toISOString().slice(0, 10);
}
